/**
 * Where a new list row goes: at the top. Doug, 6 Oct: "make it so new items
 * are added at the top of the list."
 *
 * `position` is "where this row sits", and Doug's drag rewrites it
 * (`reorder_list_items`), so it cannot also be "when this row was added" —
 * that is `created_at`, and `lastAddedOf` and the collection's Added sort read
 * that. Before this, a new row took `items.length`, the bottom, and both
 * readers used the largest position as the newest row; moving new rows to the
 * top would have turned them upside down without a word.
 *
 * The top is one above the smallest position the list holds, done rows
 * included (they share the numbering), so positions go negative over time.
 * The column is a plain integer with no floor, and the next drag renumbers
 * the whole list from 0 anyway. `count` rows added together (a grocery line
 * naming three items) take the slots above that, in the order they were
 * named: the first one named is the top one.
 *
 * Its own file, with no imports, so `test/` can reach it.
 */
export function topPositions(items: readonly { position: number }[], count = 1): number[] {
  const top = items.length ? Math.min(...items.map(i => i.position)) : 0
  return Array.from({ length: count }, (_, k) => top - count + k)
}

/** The position for one new row at the top. */
export const topPosition = (items: readonly { position: number }[]): number => topPositions(items, 1)[0]

/** Newest first, by when the row was written — not by where it sits. A row
 *  with no `created_at` is an optimistic one the server has not answered for
 *  yet, which is to say the newest. */
export const byAddedDesc = (a: { created_at?: string }, b: { created_at?: string }): number => {
  const x = a.created_at ?? '\uffff', y = b.created_at ?? '\uffff'
  return x < y ? 1 : x > y ? -1 : 0
}
